import React from 'react';
import '../styles/App.css';
import wechatQRCode from '../images/kawo-qr.jpg';


// MAIN REACT CLASS DECLARATION
// =================================================================================================
class SplashComponent extends React.Component {


	// REACT APP CONSTRUCTOR
	// =============================================================================================
	constructor( props ) {

		super( props );

		window.mixpanel.track( 'Pageview', {
			app: 'video-to-gif',
			action: 'wechat-qr'
		} );
	}


	// MAIN RENDER METHOD
	// =============================================================================================
	render() {

		return (
			<div id="qrCode" onClick={( e ) => this.props.App.setState( prevState => ({ showWechatQR: false }) )}>

				<div className="qr-container">

					<div className="btn-group">

						<div className="btn-text">
							<p>Follow us on WeChat</p>
						</div>

						<div className="btn btn-close"
							 onClick={( e ) => this.props.App.setState( prevState => ({ showWechatQR: false }) )}/>
					</div>

					<img src={wechatQRCode}/>

				</div>
			</div>
		);
	}
}

export default SplashComponent;



// WEBPACK FOOTER //
// ./src/app/scenes/wechat-qr.js